import { render, staticRenderFns } from "./realTimeStare.vue?vue&type=template&id=4b505c12&scoped=true&"
import script from "./realTimeStare.vue?vue&type=script&lang=js&"
export * from "./realTimeStare.vue?vue&type=script&lang=js&"
import style0 from "./realTimeStare.vue?vue&type=style&index=0&id=4b505c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b505c12",
  null
  
)

export default component.exports